'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

export function UrlHashAutoScroller({ behavior = 'smooth' }: { behavior?: ScrollBehavior }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const hash = window.location.hash.split('#')[1];
    if (!hash) return;

    const element = document.getElementById(hash);
    if (!element) return;

    element.scrollIntoView({
      behavior: behavior,
      block: 'start',
      inline: 'nearest',
    });
  }, [pathname, searchParams]);

  return null;
}
